export default __webpack_public_path__ + "static/media/why-choose.ba0f8c78.svg";